import { CircularProgress, Stack } from '@mui/material';

export const FullCirclarProgress = () => {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
      <CircularProgress />
    </Stack>
  );
};
